import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TemplateService } from '@services/template.service';
import { DeleteTemplateComponent } from '../pop-up/delete-template/delete-template.component';

@Component({
    selector: 'app-template-detail',
    templateUrl: './template-detail.component.html',
    styleUrls: ['./template-detail.component.scss'],
    standalone: false
})
export class TemplateDetailComponent implements OnChanges {
  @Input() records;
  @Input() path;
  @Input() isNote: boolean = false;
	@Output() deleteFile = new EventEmitter<boolean>();
  constructor(private _templateService: TemplateService,	private modalService: NgbModal
    ) {


   }

   ngOnChanges() {
  }

  deleteItem(id,requirementId,storageId,templatecustomid){

    const body ={
      id:id,
      requirementid:requirementId,
      storageid:storageId,
      templatecustomid:templatecustomid
    };

    const modalRef = this.modalService.open(DeleteTemplateComponent, {
			size: 'md', backdrop: 'static',
			keyboard: false
		});
		modalRef.componentInstance.body = body;
		modalRef.componentInstance.title = 'Templates';
		modalRef.componentInstance.deleteFile.subscribe(deleteFile => {
			if (deleteFile) {
        this.deleteFile.emit(true);

				// this.alertLoading = true;
				// this.loadAlerts();
				// this.loadHistory();
			}
		});


    // this._templateService.Delete(body);
    // this._templateService.Delete(body).subscribe(resp => {
    //   console.log(resp)
    // });
  }

}


